<template>
  <o-section
    :level="level + 1"
    :title="label || schema.verbose_name"
    body-classes="p-0"
    not-closable
  >
    <o-item-editable-table
      v-model="items"
      :default-new-value="newChild"
      :item-name="schema.verbose_name"
      disable-add
      disable-delete
      disable-move
      @change="changed"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'task_type')">
          {{ schema.fields.task_type.label }}
        </th>
        <th v-if="canSee(schema, 'when')">{{ schema.fields.when.label }}</th>
        <th v-if="canSee(schema, 'start_time')">
          {{ schema.fields.start_time.label }}
        </th>
        <th v-if="canSee(schema, 'truck')">{{ schema.fields.truck.label }}</th>
        <th>Action</th>
      </template>
      <template slot="o-body" slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'task_type')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="task_type"
          >
            <o-select
              v-model="items[index].task_type"
              :form-state="formState"
              :items="optionCodeJobTaskTypeItems"
              :loading="optionCodeJobTaskTypeWorking"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              add-title="Create New"
              allow-add
              name="task_type"
              nolabel
              sort-field="description"
              store-name="CodeJobTaskType"
              text-field="description"
              v-bind="schema.fields.task_type"
              value-field="id"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <code-job-task-type-form
                  :form-state="formState"
                  :item="item"
                  :server-errors="serverErrors"
                  in-modal
                ></code-job-task-type-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'when')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="when"
          >
            <o-date-time
              v-model="items[index].when"
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              hide-time
              name="when"
              nolabel
              v-bind="schema.fields.when"
            ></o-date-time>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'start_time')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="start_time"
          >
            <o-text-field
              v-model="items[index].start_time"
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="start_time"
              nolabel
              v-bind="schema.fields.start_time"
            ></o-text-field>
          </o-widget-wrapper>
        </td>

        <td v-if="canSee(schema, 'truck')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="truck"
          >
            <o-select
              v-model="items[index].truck"
              :form-state="formState"
              :items="optionCodeTruckItems"
              :loading="optionCodeTruckWorking"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              add-title="Create New"
              allow-add
              name="truck"
              nolabel
              sort-field="name"
              store-name="CodeTruck"
              text-field="name"
              v-bind="schema.fields.truck"
              value-field="id"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <code-truck-form
                  :form-state="formState"
                  :item="item"
                  :server-errors="serverErrors"
                  in-modal
                ></code-truck-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee('action')">
          <o-report-button
            :do-save="_doSave"
            :filename="filename(items[index].when)"
            :params="params(items[index].when)"
            format="pdf"
            report-name="delivery_docket_with_images"
          >
            <printer-icon/>
            Delivery Docket
          </o-report-button>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import schema from "../../schema/index";
import {cleanUpModel} from "../../../vue-ocom/schema/schema_vuetify";
import {CreateDefaultItem} from "../../../vue-ocom/schema/schema_utils";
import {CreateCodeTableFetchMixin, CreateFormStateMixin, CreateGroupPermissionMixin} from "../../../vue-ocom/mixins";
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../vue-ocom/components/layout/OSection";
import ODoServerActionButton from "../../../vue-ocom/components/forms/ODoServerActionButton.vue";
import OReportButton from "@/vue-ocom/reports/OReportButton.vue";
import PrinterIcon from "vue-material-design-icons/Printer.vue"

export default {
  name: "JobTaskFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("JobTask"),
    CreateCodeTableFetchMixin(["CodeTruck", "CodeJobTaskType"])
  ],
  components: {OReportButton, OItemEditableTable, OSection, ODoServerActionButton, PrinterIcon},
  model: {
    prop: "items",
    event: "changed"
  },
  props: {
    items: {
      type: Array,
      default: () => {
      }
    },
    job: {
      type: Object,
      default: () => {
      }
    },
    label: {type: String, default: null},
    validators: {type: Object, default: () => null},
    level: {type: Number, default: 0}
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.JobTask,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.JobTask)
    };
  },
  methods: {
    params(delivery_date) {
      var job_id = this.job.id;
      return {
        "job_id": job_id,
        "Delivery_Date": delivery_date,
      }
    },
    filename(delivery_date) {
      return "Docket " + this.job.id + " " + delivery_date + ".pdf"
    },
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    }
  },
  computed: {},
  created() {
    // this.loadCodeTables()
    console.log(this.job);
  }
};
</script>
